var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "144.51mm",
    height: "144.51mm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M 0.00,342.00            C 0.00,342.00 0.00,408.00 0.00,408.00              0.63,461.53 51.55,511.75 105.00,512.00              105.00,512.00 359.00,512.00 359.00,512.00              359.00,512.00 406.00,512.00 406.00,512.00              438.70,511.95 471.80,493.07 490.84,467.00              503.32,449.91 511.97,427.32 512.00,406.00              512.00,406.00 512.00,384.00 512.00,384.00              512.00,384.00 512.00,342.00 512.00,342.00              512.00,342.00 0.00,342.00 0.00,342.00 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M 0.00,171.00            C 0.00,171.00 0.00,341.00 0.00,341.00              0.00,341.00 512.00,341.00 512.00,341.00              512.00,341.00 512.00,171.00 512.00,171.00              512.00,171.00 0.00,171.00 0.00,171.00 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M 0.00,170.00            C 0.00,170.00 512.00,170.00 512.00,170.00              512.00,170.00 512.00,104.00 512.00,104.00              511.37,50.47 460.45,0.25 407.00,0.00              407.00,0.00 153.00,0.00 153.00,0.00              153.00,0.00 106.00,0.00 106.00,0.00              73.30,0.05 40.20,18.93 21.16,45.00              8.68,62.09 0.03,84.68 0.00,106.00              0.00,106.00 0.00,128.00 0.00,128.00              0.00,128.00 0.00,170.00 0.00,170.00 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.310780b102bd5cae8d37c820322d8513.svg";
export { ForwardRef as ReactComponent };